import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { SMART_QUERY_REQUEST, smartQuerySuccess, smartQueryFailure } from '../actions/smartQueryAction';
import { API_PATH }  from '../config';
import { authHeader } from '../helper/authHeader';

const STATION_HISTORY_API = `${API_PATH}/smart/query`;

const smartQueryApi = (stationId, params) => {
   return axios.post(`${STATION_HISTORY_API}/${stationId}`, params, 
      {
         headers: {...authHeader()},
         timeout: 60000
      }).then( (response) => response.data);
}

function* smartQuery(action) {
   let fetch = undefined;
   try {
      fetch = yield call(smartQueryApi, action.stationId, action.params);
      if (fetch) {
         if (fetch.success) {
            yield put(smartQuerySuccess({result: fetch.result}));
         } else {
            yield put(smartQueryFailure('系統處理發生問題, 稍後再試 !'));
         }
      } else {
         yield put(smartQueryFailure('資料錯誤 !'));
      }

   } catch (error) {
      yield put(smartQueryFailure(`資料錯誤, ${error.message}`));
   }
}

export default function* watchSmartQueryAction() {
   yield takeEvery(SMART_QUERY_REQUEST, smartQuery);
}